import TAndCModal from "components/TAndCModal/TAndCModal";
import PrivacyPolicyModal from "components/PrivacyPolicyModal/PrivacyPolicyModal";
import { useState } from "react";
import "./footer.scss";

function Footer() {
  const [showTAndCModal, setShowTAndCModal] = useState(false);
  const [showPrivacyPolicyModal, setShowPrivacyPolicyModal] = useState(false);
  return (
    <footer className="cif__footer px-3 py-4 d-flex justify-content-between align-items-center font-sm container-fluid">
      <div>
        Need help? Call us at{" "}
        <a className="cursor-pointer" href="tel:+1  800-454-1538">
          <u>800-454-1538</u>
        </a>
      </div>
      <div className="d-flex justify-content-between align-items-center gap-5">
        <div
          className="mx-2 cursor-pointer"
          onClick={() => setShowTAndCModal(true)}
        >
          Terms of service
        </div>
        <span>© 2022 – 2023 All rights reserved</span>
        <div
          className="mx-2 cursor-pointer"
          onClick={() => setShowPrivacyPolicyModal(true)}
        >
          Privacy policy
        </div>
      </div>
      <TAndCModal
        showTAndCModal={showTAndCModal}
        setShowTAndCModal={setShowTAndCModal}
      />
      <PrivacyPolicyModal
        showPrivacyPolicyModal={showPrivacyPolicyModal}
        setShowPrivacyPolicyModal={setShowPrivacyPolicyModal}
      />
    </footer>
  );
}

export default Footer;
